import styled from '@emotion/styled';
import { mapInFlowAssetToCSS } from 'components/publicWebsiteV2/util/mappers';
import type { WInFlowThemeComponentAssetSummaryView } from '@zola/svc-web-api-ts-client';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';

export const HomepageDividerFlourish = styled.div<{
  inFlowAsset?: WInFlowThemeComponentAssetSummaryView;
}>`
  margin-bottom: ${SPACING.XL};
  ${({ inFlowAsset }) => mapInFlowAssetToCSS(inFlowAsset)}
`;

export const PaddedContentContainer = styled.div<{ textAlignment: string }>`
  padding-left: ${SPACING.S32};
  padding-right: ${SPACING.S32};
  text-align: ${({ textAlignment }) => textAlignment.toLowerCase()};
`;
